import { GameManager } from "./../../GameManager";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";

export class LevelsEditorScene extends Phaser.Scene {

    public static currentInstance: LevelsEditorScene;

    public filesContainer: Phaser.GameObjects.Container;

    constructor() {

        super("LevelsEditorScene");
        LevelsEditorScene.currentInstance = this;
    }

    public create(): void {
        
        GameVars.currentScene = this;

        this.cameras.main.setBackgroundColor(0x6cd9b2);

        this.filesContainer = new Phaser.GameObjects.Container(this);
        this.add.existing(this.filesContainer);

        let lobbyBtn = new Phaser.GameObjects.Graphics(this);
        lobbyBtn.setPosition(95, 45);
        lobbyBtn.fillStyle(0xffffff);
        lobbyBtn.fillRoundedRect(-75, -25, 150, 50, 5);
        lobbyBtn.lineStyle(5, 0x000000);
        lobbyBtn.strokeRoundedRect(-75, -25, 150, 50, 5);
        lobbyBtn.setInteractive(new Phaser.Geom.Rectangle(-75, -25, 150, 50), Phaser.Geom.Rectangle.Contains);
        lobbyBtn.on("pointerdown", this.onClickLobby, this);
        this.filesContainer.add(lobbyBtn);

        let lobbyText = new Phaser.GameObjects.Text(this, 95, 45,  "LOBBY\nSCENE", {fontFamily: "Rubik-Regular", fontSize: "20px", color: "#000000", align: "center"});
        lobbyText.setOrigin(.5);
        this.filesContainer.add(lobbyText);

        let text = new Phaser.GameObjects.Text(this, GameConstants.GAME_WIDTH / 2 - 250 - 120, 150, "TEST", {fontFamily: "Rubik-Regular", fontSize: "30px", color: "#000000", align: "center"});
        text.setOrigin(.5);
        this.add.existing(text);

        let btn = new Phaser.GameObjects.Image(this, GameConstants.GAME_WIDTH / 2 - 250, 150, "texture_atlas_1", "btn_stage_1_playable_idle");
        btn.setInteractive();
        btn.on("pointerdown", () => {
            GameVars.editorIndex = 0;
            GameVars.currentScene.scene.start("LevelFileScene");
        }, this);
        this.add.existing(btn);

        text = new Phaser.GameObjects.Text(this, GameConstants.GAME_WIDTH / 2 - 250, 150 - 10, "0", {fontFamily: "Rubik-Regular", fontSize: "20px", color: "#FFFFFF", align: "center"});
        text.setOrigin(.5);
        this.add.existing(text);

        for (let i = 0; i < 5; i++) {

            let text = new Phaser.GameObjects.Text(this, GameConstants.GAME_WIDTH / 2 - 250 - 120, 250 + i * 100, "ZONA " + (i + 1), {fontFamily: "Rubik-Regular", fontSize: "30px", color: "#000000", align: "center"});
            text.setOrigin(.5);
            this.add.existing(text);

            for (let j = 0; j < 6; j++) {

                let btn = new Phaser.GameObjects.Image(this, GameConstants.GAME_WIDTH / 2 - 250 + j * 100, 250 + i * 100, "texture_atlas_1", "btn_stage_" + (i + 1) + "_playable_idle");
                btn.setInteractive();
                btn.on("pointerdown", () => {
                    GameVars.editorIndex = (i * 6 + j + 1);
                    GameVars.currentScene.scene.start("LevelFileScene");
                }, this);
                this.add.existing(btn);

                let text = new Phaser.GameObjects.Text(this, GameConstants.GAME_WIDTH / 2 - 250 + j * 100, 250 + i * 100 - 10, (i * 6 + j + 1).toString(), {fontFamily: "Rubik-Regular", fontSize: "20px", color: "#FFFFFF", align: "center"});
                text.setOrigin(.5);
                this.add.existing(text);
            }
        }
    }

    private onClickLobby(): void {

        GameManager.enterLobbyScene();
    }
}
